import { IHeaderDecorator } from 'decorators/HeaderDecorator';
import { API_URLS } from 'constants/apiUrls';
import { IPartnerInitialResponse } from './interfaces';

export default class AppRepository {
    constructor(private readonly repository: IHeaderDecorator) {}

    public setApiUrl(apiUrl: string): void {
        this.repository.setApiUrl(apiUrl);
    }

    public setPartnerCode = (partnerCode: string) => {
        this.repository.setPartnerCode(partnerCode);
    };

    public fetch(): Promise<IPartnerInitialResponse> {
        return this.repository.get<IPartnerInitialResponse>(API_URLS.INITIAL);
    }
}
